/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GMWOverview } from "./GMWOverview";
import {
  GMWOverviewFromJSON,
  GMWOverviewFromJSONTyped,
  GMWOverviewToJSON,
  GMWOverviewToJSONTyped,
} from "./GMWOverview";

/**
 *
 * @export
 * @interface ApiGmwOverviewList200Response
 */
export interface ApiGmwOverviewList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGmwOverviewList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGmwOverviewList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwOverviewList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GMWOverview>}
   * @memberof ApiGmwOverviewList200Response
   */
  results: Array<GMWOverview>;
}

/**
 * Check if a given object implements the ApiGmwOverviewList200Response interface.
 */
export function instanceOfApiGmwOverviewList200Response(
  value: object
): value is ApiGmwOverviewList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGmwOverviewList200ResponseFromJSON(json: any): ApiGmwOverviewList200Response {
  return ApiGmwOverviewList200ResponseFromJSONTyped(json, false);
}

export function ApiGmwOverviewList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwOverviewList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GMWOverviewFromJSON),
  };
}

export function ApiGmwOverviewList200ResponseToJSON(json: any): ApiGmwOverviewList200Response {
  return ApiGmwOverviewList200ResponseToJSONTyped(json, false);
}

export function ApiGmwOverviewList200ResponseToJSONTyped(
  value?: ApiGmwOverviewList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GMWOverviewToJSON),
  };
}
